import { useState } from "react"
import "./styles/thanku.css"
export default function ThankU() {
  const [orderNumber] = useState(localStorage.getItem("orderNumber"))
  const gotoHome = () => {
    localStorage.removeItem("orderNumber")
    setTimeout(() => {
      window.location.pathname = "/"
    })
  }
  return(
    <div className="thankyou">
      <h1>感謝親~ 我們將為您盡速出貨</h1>
      <h5>訂單編號: {orderNumber}</h5>
      <button type="button" onClick={ gotoHome }>繼續選購</button>
    </div>
  )
}